unit View.Produtos_Associacao.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, System.StrUtils, UUtils, UHelperServer,
  XData.Web.Client, WEBLib.WebCtrls, UPersonalizacao_Tabela.Interfaces,
  UPersonalizacao_Tabela, System.Generics.Collections;

type
  TFViewProdutos_AssociacaoList = class(TForm)
    Produtos_AssociacaoDataset: TXDataWebDataSet;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    Produtos_AssociacaoDatasetassociacaostatus: TXDataWebDatasetField;
    Produtos_AssociacaoDatasetassociacaoinclusao: TDateTimeField;
    Produtos_AssociacaoDatasetassociacaoalteracao: TDateTimeField;
    Produtos_AssociacaoDatasetaliadoNome_Fantasia: TXDataWebDatasetField;
    Produtos_AssociacaoDatasetnome: TStringField;
    Produtos_AssociacaoDatasetcodigo_barras: TStringField;
    Produtos_AssociacaoDatasetassociacaofsprodnome: TXDataWebDatasetField;
    Produtos_AssociacaoDatasetassociacaoimagem_aprovacao: TXDataWebDatasetField;
    Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras: TXDataWebDatasetField;
    Produtos_AssociacaoDatasetassociacaofsprodid: TXDataWebDatasetField;
    Produtos_AssociacaoDatasetid: TIntegerField;
    XDataWebClientAssociacao: TXDataWebClient;
    Produtos_AssociacaoDatasetselecionado: TBooleanField;
    btnAprovar: TButton;
    Produtos_AssociacaoDatasetnova_imagem: TStringField;
    btnReprovar: TButton;
    Produtos_AssociacaoDatasetassociacaofsprodimagem: TStringField;
    XDataWebClientGetFsProd: TXDataWebClient;
    Produtos_AssociacaoDatasetfsprod_nome_cds: TStringField;
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds: TStringField;
    Produtos_AssociacaoDatasetfsprod_imagem_cds: TStringField;
    Produtos_AssociacaoDataseterro: TStringField;
    Produtos_AssociacaoDatasetassociacaoid: TIntegerField;
    cbbAssociacaoStatus: TComboBox;
    divAliado: THTMLDiv;
    lblAliado: TLabel;
    edtAliadoNome: TEdit;
    btnPesquisarAliado: TButton;
    btnPesquisarAssociacao: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure Produtos_AssociacaoDatasetAfterOpen(DataSet: TDataSet);
    procedure XDataWebClientAssociacaoError(Error: TXDataClientError);
    procedure XDataWebClientAssociacaoLoad(Response: TXDataClientResponse);
    procedure XDataWebClientGetFsProdLoad(Response: TXDataClientResponse);
    procedure XDataWebClientGetFsProdError(Error: TXDataClientError);
    [async]
    procedure btnAprovarClick(Sender: TObject); async;
    [async]
    procedure btnReprovarClick(Sender: TObject); async;
    procedure btnPesquisarAliadoClick(Sender: TObject);
    procedure btnPesquisarAssociacaoClick(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FFsProdLookupAssociacaoId: string;
    FFsProdLookupCodigoBarras: string;
    procedure SelecionarImagemGrid(const pCodigoAssociacao: string; pRecNo: Integer);
    procedure AplicarImagemGridNoDataSet(const pCodigoAssociacao: string;
      pRecNo: Integer; const pBase64: string; pRemover: Boolean);
    function GetHtmlCampoEditavelGrid(const pCodigoAssociacao, pCampo,
      pValorOriginal: string; pRecNo: Integer): string;
    procedure AplicarEdicaoGridNoDataSet(const pCodigoAssociacao, pCampo,
      pValor: string; pRecNo: Integer);
    procedure AplicarSelecionadoNoDataSet(const pCodigoAssociacao: string;
      pSelecionado: Boolean; pRecNo: Integer);
    procedure MarcarDesmarcarTodosNoDataSet;
    procedure AtualizarTextoBotaoMarcarTodos;
    procedure SincronizarNovaImagemComImagemAprovacao;
    procedure ExibirMensagemInformacao(const pMensagem: string);
    procedure ConsultarFsProdPorCodigoBarras(const pCodigoAssociacao,
      pCodigoBarras: string);
    procedure AtualizarFsProdPorCodigoBarras(const pCodigoAssociacao,
      pCodigoBarrasConsultado, pNomeFsProd, pCodigoBarrasFsProd,
      pImagemFsProd: string);
    procedure RemoverRegistrosSemErro(var pDicionarioErros : TDictionary<Integer, string>);
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewProdutos_AssociacaoList: TFViewProdutos_AssociacaoList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewProdutos_AssociacaoList }

class function TFViewProdutos_AssociacaoList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewProdutos_AssociacaoList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewProdutos_AssociacaoList, AElementID, Result, @AfterCreate);
end;

procedure TFViewProdutos_AssociacaoList.SelecionarImagemGrid(
  const pCodigoAssociacao: string; pRecNo: Integer);
begin
  asm
    window.fsProdAssociacaoImagemPending = {
      associacao: pCodigoAssociacao || '',
      recno: pRecNo || 0
    };

    var lInput = document.getElementById('gridImagePicker');
    if (lInput) {
      lInput.value = '';
      lInput.click();
    }
  end;
end;

procedure TFViewProdutos_AssociacaoList.AplicarImagemGridNoDataSet(
  const pCodigoAssociacao: string; pRecNo: Integer; const pBase64: string;
  pRemover: Boolean);
var
  lRecNo: Integer;
  lEncontrou: Boolean;
  lCodigoAtual: string;
  lNovaImagem: TField;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  lRecNo := Produtos_AssociacaoDataset.RecNo;
  lEncontrou := False;

  Produtos_AssociacaoDataset.DisableControls;
  try
    if Trim(pCodigoAssociacao) <> EmptyStr then
    begin
      Produtos_AssociacaoDataset.First;
      while not Produtos_AssociacaoDataset.Eof do
      begin
        lCodigoAtual := Trim(Produtos_AssociacaoDataset.FieldByName('associacao.id').AsString);
        if lCodigoAtual = Trim(pCodigoAssociacao) then
        begin
          lEncontrou := True;
          Break;
        end;

        Produtos_AssociacaoDataset.Next;
      end;
    end;

    if (not lEncontrou) and (pRecNo > 0) and (pRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    begin
      Produtos_AssociacaoDataset.RecNo := pRecNo;
      lEncontrou := True;
    end;

    if lEncontrou then
    begin
      lNovaImagem := Produtos_AssociacaoDataset.FieldByName('nova_imagem');
      if pRemover then
      begin
        if lNovaImagem.IsNull or (lNovaImagem.AsString <> EmptyStr) then
        begin
          Produtos_AssociacaoDataset.Edit;
          lNovaImagem.AsString := EmptyStr;
          Produtos_AssociacaoDataset.Post;
        end;
      end
      else if Trim(pBase64) <> EmptyStr then
      begin
        if lNovaImagem.AsString <> pBase64 then
        begin
          Produtos_AssociacaoDataset.Edit;
          lNovaImagem.AsString := pBase64;
          Produtos_AssociacaoDataset.Post;
        end;
      end;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;
end;

function TFViewProdutos_AssociacaoList.GetHtmlCampoEditavelGrid(
  const pCodigoAssociacao, pCampo, pValorOriginal: string; pRecNo: Integer): string;
var
  lValor,
  lOnKeyPress,
  lStyleExtra: string;
begin
  lValor := pValorOriginal;
  lValor := StringReplace(lValor, '&', '&amp;', [rfReplaceAll]);
  lValor := StringReplace(lValor, '<', '&lt;', [rfReplaceAll]);
  lValor := StringReplace(lValor, '>', '&gt;', [rfReplaceAll]);

  lOnKeyPress := EmptyStr;
  lStyleExtra := EmptyStr;

  if pCampo = 'codigo_barras' then
    lOnKeyPress := ' onkeypress="if ((event.key.length === 1) && !(/[0-9]/.test(event.key))) event.preventDefault();"';

  if pCampo = 'nome' then
    lStyleExtra := ' style="text-transform:uppercase;"';

  Result := '<span class="d-inline-flex align-items-center w-100" style="gap:6px;">' +
    '<span contenteditable="true" class="d-inline-block flex-grow-1"' +
    lStyleExtra +
    ' data-associacao="' + pCodigoAssociacao + '" data-campo="' + pCampo + '"' +
    ' data-recno="' + IntToStr(pRecNo) + '"' +
    ' title="Clique aqui para editar"' +
    lOnKeyPress +
    ' onfocus="this.dataset.valorOriginal = this.innerText; this.dataset.confirmarEdicao = '''';"' +
    ' onkeydown="if (event.key === ''Enter'') { event.preventDefault(); this.dataset.confirmarEdicao = ''1''; this.blur(); }"' +
    ' onblur="if (this.dataset.confirmarEdicao === ''1'') { window.fsProdAssociacaoApplyEdit && window.fsProdAssociacaoApplyEdit(this.dataset.associacao, this.dataset.campo, this.innerText, parseInt(this.dataset.recno || ''0'', 10)); } else { this.innerText = this.dataset.valorOriginal || this.innerText; } this.dataset.confirmarEdicao = '''';">' +
    lValor + '</span>' +
    '<i class="fas fa-pencil-alt text-primary" style="font-size:11px;opacity:.85;pointer-events:none;" title="Campo editável"></i>' +
    '</span>';
end;

procedure TFViewProdutos_AssociacaoList.AplicarEdicaoGridNoDataSet(
  const pCodigoAssociacao, pCampo, pValor: string; pRecNo: Integer);
var
  lRecNo: Integer;
  lNovoValor: string;
  lEncontrou: Boolean;
  lAtualizouCodigoBarras: Boolean;
  lCodigoAssociacaoAtual: string;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  if IndexStr(pCampo, ['nome', 'codigo_barras']) < 0 then
    Exit;

  lRecNo := Produtos_AssociacaoDataset.RecNo;
  lNovoValor := Trim(pValor);
  lEncontrou := False;
  lAtualizouCodigoBarras := False;
  lCodigoAssociacaoAtual := EmptyStr;

  Produtos_AssociacaoDataset.DisableControls;
  try
    if (pRecNo > 0) and (pRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    begin
      Produtos_AssociacaoDataset.RecNo := pRecNo;
      lEncontrou := True;
    end;

    if not lEncontrou then
    begin
      Produtos_AssociacaoDataset.First;
      while not Produtos_AssociacaoDataset.Eof do
      begin
        if Produtos_AssociacaoDatasetassociacaoid.AsString = pCodigoAssociacao then
        begin
          lEncontrou := True;
          Break;
        end;

        Produtos_AssociacaoDataset.Next;
      end;
    end;

    if lEncontrou then
    begin
      if pCampo = 'nome' then
      begin
        lNovoValor := UpperCase(lNovoValor);

        if Produtos_AssociacaoDataset.FieldByName('nome').AsString <> lNovoValor then
        begin
          Produtos_AssociacaoDataset.Edit;
          Produtos_AssociacaoDataset.FieldByName('nome').AsString := lNovoValor;
          Produtos_AssociacaoDataset.Post;
        end;
      end
      else
      begin
        if Produtos_AssociacaoDataset.FieldByName('codigo_barras').AsString <> lNovoValor then
        begin
          Produtos_AssociacaoDataset.Edit;
          Produtos_AssociacaoDataset.FieldByName('codigo_barras').AsString := lNovoValor;
          Produtos_AssociacaoDataset.Post;
          lAtualizouCodigoBarras := True;
          lCodigoAssociacaoAtual := Produtos_AssociacaoDatasetassociacaoid.AsString;
        end;
      end;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;

  if lAtualizouCodigoBarras and (Trim(lNovoValor) <> EmptyStr) then
    ConsultarFsProdPorCodigoBarras(lCodigoAssociacaoAtual, lNovoValor);
end;

procedure TFViewProdutos_AssociacaoList.ConsultarFsProdPorCodigoBarras(
  const pCodigoAssociacao, pCodigoBarras: string);
begin
  if Trim(pCodigoAssociacao) = EmptyStr then
    Exit;

  if Trim(pCodigoBarras) = EmptyStr then
    Exit;

  FFsProdLookupAssociacaoId := Trim(pCodigoAssociacao);
  FFsProdLookupCodigoBarras := Trim(pCodigoBarras);

  TUtils.ChamarDivLoading;

  XDataWebClientGetFsProd.RawInvoke('IService.GetFsProdFrontEnd', [
    Trim(pCodigoBarras)
  ]);
end;

procedure TFViewProdutos_AssociacaoList.AtualizarFsProdPorCodigoBarras(
  const pCodigoAssociacao, pCodigoBarrasConsultado, pNomeFsProd,
  pCodigoBarrasFsProd, pImagemFsProd: string);
var
  lRecNo: Integer;
  lEncontrou: Boolean;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  if Trim(pCodigoAssociacao) = EmptyStr then
    Exit;

  lRecNo := Produtos_AssociacaoDataset.RecNo;
  lEncontrou := False;

  Produtos_AssociacaoDataset.DisableControls;
  try
    Produtos_AssociacaoDataset.First;
    while not Produtos_AssociacaoDataset.Eof do
    begin
      if Produtos_AssociacaoDatasetassociacaoid.AsString = pCodigoAssociacao then
      begin
        lEncontrou := True;
        Break;
      end;

      Produtos_AssociacaoDataset.Next;
    end;

    if lEncontrou and
      SameText(Trim(Produtos_AssociacaoDataset.FieldByName('codigo_barras').AsString),
      Trim(pCodigoBarrasConsultado)) then
    begin
      Produtos_AssociacaoDataset.Edit;
      Produtos_AssociacaoDatasetfsprod_nome_cds.AsString := pNomeFsProd;
      Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.AsString :=
        pCodigoBarrasFsProd;
      Produtos_AssociacaoDatasetfsprod_imagem_cds.AsString := pImagemFsProd;
      Produtos_AssociacaoDataset.Post;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;
end;


procedure TFViewProdutos_AssociacaoList.AplicarSelecionadoNoDataSet(
  const pCodigoAssociacao: string; pSelecionado: Boolean; pRecNo: Integer);
var
  lRecNo: Integer;
  lEncontrou: Boolean;
  lNomeVazio: Boolean;
  lCodigoBarrasVazio: Boolean;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  lRecNo := Produtos_AssociacaoDataset.RecNo;
  lEncontrou := False;

  Produtos_AssociacaoDataset.DisableControls;
  try
    if (pRecNo > 0) and (pRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    begin
      Produtos_AssociacaoDataset.RecNo := pRecNo;
      if Produtos_AssociacaoDatasetassociacaoid.AsString = pCodigoAssociacao then
        lEncontrou := True;
    end;

    if not lEncontrou then
    begin
      Produtos_AssociacaoDataset.First;
      while not Produtos_AssociacaoDataset.Eof do
      begin
        if Produtos_AssociacaoDatasetassociacaoid.AsString = pCodigoAssociacao then
        begin
          lEncontrou := True;
          Break;
        end;

        Produtos_AssociacaoDataset.Next;
      end;
    end;

    if lEncontrou and pSelecionado then
    begin
      lNomeVazio := Trim(Produtos_AssociacaoDataset.FieldByName('nome').AsString) = EmptyStr;
      lCodigoBarrasVazio := Trim(Produtos_AssociacaoDataset.FieldByName('codigo_barras').AsString) = EmptyStr;

      if lNomeVazio then
      begin
        TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nome não pode ser vazio');
        asm
          var lCheckbox = document.querySelector('input.form-check-input[data-associacao="' + pCodigoAssociacao + '"]');
          if (lCheckbox) {
            lCheckbox.checked = false;
          }
        end;
        Exit;
      end;

      if lCodigoBarrasVazio then
      begin
        TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Código de barras não pode ser vazio');
        asm
          var lCheckbox = document.querySelector('input.form-check-input[data-associacao="' + pCodigoAssociacao + '"]');
          if (lCheckbox) {
            lCheckbox.checked = false;
          }
        end;
        Exit;
      end;
    end;

    if lEncontrou and (Produtos_AssociacaoDatasetselecionado.AsBoolean <> pSelecionado) then
    begin
      Produtos_AssociacaoDataset.Edit;
      Produtos_AssociacaoDatasetselecionado.AsBoolean := pSelecionado;
      Produtos_AssociacaoDataset.Post;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;

  AtualizarTextoBotaoMarcarTodos;
end;

procedure TFViewProdutos_AssociacaoList.MarcarDesmarcarTodosNoDataSet;
var
  lRecNo: Integer;
  lMarcarTodos: Boolean;
  lPossuiNomeVazio: Boolean;
  lPossuiCodigoBarrasVazio: Boolean;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  lMarcarTodos := False;
  lPossuiNomeVazio := False;
  lPossuiCodigoBarrasVazio := False;
  lRecNo := Produtos_AssociacaoDataset.RecNo;

  Produtos_AssociacaoDataset.DisableControls;
  try
    Produtos_AssociacaoDataset.First;
    while not Produtos_AssociacaoDataset.Eof do
    begin
      if not Produtos_AssociacaoDatasetselecionado.AsBoolean then
      begin
        lMarcarTodos := True;
        Break;
      end;

      Produtos_AssociacaoDataset.Next;
    end;

    Produtos_AssociacaoDataset.First;
    while not Produtos_AssociacaoDataset.Eof do
    begin
      if Produtos_AssociacaoDatasetselecionado.AsBoolean <> lMarcarTodos then
      begin
        if lMarcarTodos and (Trim(Produtos_AssociacaoDataset.FieldByName('nome').AsString) = EmptyStr) then
          lPossuiNomeVazio := True
        else if lMarcarTodos and (Trim(Produtos_AssociacaoDataset.FieldByName('codigo_barras').AsString) = EmptyStr) then
          lPossuiCodigoBarrasVazio := True
        else
        begin
          Produtos_AssociacaoDataset.Edit;
          Produtos_AssociacaoDatasetselecionado.AsBoolean := lMarcarTodos;
          Produtos_AssociacaoDataset.Post;
        end;
      end;

      Produtos_AssociacaoDataset.Next;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;

  if lPossuiNomeVazio then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nome não pode ser vazio')
  else if lPossuiCodigoBarrasVazio then
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Código de barras não pode ser vazio');

  AtualizarTextoBotaoMarcarTodos;
end;

procedure TFViewProdutos_AssociacaoList.AtualizarTextoBotaoMarcarTodos;
var
  lTodosSelecionados: Boolean;
  lQuantidadeSelecionados: Integer;
  lRecNo: Integer;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  lTodosSelecionados := Produtos_AssociacaoDataset.RecordCount > 0;
  lQuantidadeSelecionados := 0;
  lRecNo := Produtos_AssociacaoDataset.RecNo;

  Produtos_AssociacaoDataset.DisableControls;
  try
    Produtos_AssociacaoDataset.First;
    while not Produtos_AssociacaoDataset.Eof do
    begin
      if Produtos_AssociacaoDatasetselecionado.AsBoolean then
        Inc(lQuantidadeSelecionados);

      if not Produtos_AssociacaoDatasetselecionado.AsBoolean then
        lTodosSelecionados := False;

      Produtos_AssociacaoDataset.Next;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;

  asm
    var lBtn = document.getElementById('btnMarcarDesmarcarTodos');
    var lLblSelecionados = document.getElementById('lblProdutosSelecionados');

    if (lBtn) {
      if (lTodosSelecionados) {
        lBtn.innerHTML = '<span class="btn-label"><i class="fas fa-check-square"></i></span> Desmarcar Todos';
      } else {
        lBtn.innerHTML = '<span class="btn-label"><i class="fas fa-check-square"></i></span> Marcar Todos';
      }
    }

    if (lLblSelecionados) {
      lLblSelecionados.textContent = String(lQuantidadeSelecionados) + ' Produto(s) Selecionado(s)';
    }
  end;
end;

procedure TFViewProdutos_AssociacaoList.ExibirMensagemInformacao(
  const pMensagem: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, pMensagem);
end;

procedure TFViewProdutos_AssociacaoList.btnAprovarClick(Sender: TObject);
var
  lImagemJson : string;
  lStatus : Integer;
  lJson : TJSObject;
  lArray: TJSArray;
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa operação?')) then
  begin
    TUtils.ChamarDivLoading;
    Produtos_AssociacaoDataset.DisableControls;
    Produtos_AssociacaoDataset.First;
    lArray := TJSArray.new;

    try
      while not Produtos_AssociacaoDataset.Eof do
      begin
        if Produtos_AssociacaoDataset.FieldByName('selecionado').AsBoolean then
        begin
          lJson := TJSObject.New;

          lStatus := Produtos_AssociacaoDataset.FieldByName('associacao.status').AsInteger;

          lJson['codigo_associacao'] := Produtos_AssociacaoDataset.FieldByName('associacao.id').AsInteger;
          lJson['status'] := lStatus;

          lImagemJson := Produtos_AssociacaoDataset.FieldByName('nova_imagem').AsString;

          if lStatus = 3 then
          begin
            lJson['produto_nome'] := UpperCase(Produtos_AssociacaoDataset.FieldByName('nome').AsString);
            lJson['codigo_barras'] := Produtos_AssociacaoDataset.FieldByName('codigo_barras').AsString;
            lJson['utilizar_codigo_barras_existente'] := not Produtos_AssociacaoDataset.FieldByName('fsprod_codigo_barras_cds').AsString.IsEmpty;
          end;

          if Trim(lImagemJson) = EmptyStr then
            lJson['imagem_base64'] := JSValue(null)
          else
            lJson['imagem_base64'] := lImagemJson;


          lArray.push(lJson);
        end;

        Produtos_AssociacaoDataset.Next;
      end;
    finally
      Produtos_AssociacaoDataset.EnableControls;
    end;

    if lArray.Length = 0 then
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum produto selecionado!')
    else
    begin
      XDataWebClientAssociacao.RawInvoke('IService.GerenciarAssociacaoProdutos', [lArray]);
    end;
  end;
end;

procedure TFViewProdutos_AssociacaoList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewProdutos_AssociacaoList.btnPesquisarAliadoClick(
  Sender: TObject);
begin
  THelperServer.ChamarConsulta('Aliados', 'Aliado', edtAliadoNome);
end;

procedure TFViewProdutos_AssociacaoList.btnPesquisarAssociacaoClick(
  Sender: TObject);
var
  lFiltro : string;
begin
  case cbbAssociacaoStatus.ItemIndex of
    0: lFiltro := '((associacao.status eq 2) or (associacao.status eq 3))';
    else lFiltro := '(associacao.status eq '+IntToStr(cbbAssociacaoStatus.ItemIndex + 1) +')';
  end;

  if edtAliadoNome.Tag <> 0 then
    lFiltro := lFiltro + ' and (aliado_id eq '+edtAliadoNome.Tag.ToString+')';

  FGridPlugin.FDatasetPlugin.FFilterPadrao := lFiltro;
  FGridPlugin.Load;
end;

procedure TFViewProdutos_AssociacaoList.btnReprovarClick(Sender: TObject);
var
  lJson : TJSObject;
  lArray: TJSArray;
begin
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja realizar essa operação?')) then
  begin
    TUtils.ChamarDivLoading;

    Produtos_AssociacaoDataset.DisableControls;
    Produtos_AssociacaoDataset.First;
    lArray := TJSArray.new;

    try
      while not Produtos_AssociacaoDataset.Eof do
      begin
        if Produtos_AssociacaoDataset.FieldByName('selecionado').AsBoolean then
        begin
          lJson := TJSObject.New;

          lJson['codigo_associacao'] := Produtos_AssociacaoDataset.FieldByName('associacao.id').AsInteger;
          lJson['status'] := 0;

          lArray.push(lJson);
        end;

        Produtos_AssociacaoDataset.Next;
      end;
    finally
      Produtos_AssociacaoDataset.EnableControls;
    end;

    if lArray.Length = 0 then
      TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhum produto selecionado!')
    else
      XDataWebClientAssociacao.RawInvoke('IService.GerenciarAssociacaoProdutos', [lArray]);
  end;
end;

procedure TFViewProdutos_AssociacaoList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['aliado.Nome_Fantasia',
      'nome', 'codigo_barras', 'fsprod_nome_cds', 'fsprod_codigo_barras_cds',
      'associacao.imagem_aprovacao']) of
      0, 1, 2, 3, 4: AClassName := 'text-start';
      5: AClassName := 'text-center';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewProdutos_AssociacaoList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
var
  lCodigoAssociacao,
  lCampo,
  lChecked,
  lImagemSrc: string;
  lNovaImagemField: TField;
  lTemImagem: Boolean;
  lTemErro: Boolean;
  lIgnorarPinturaErro: Boolean;
begin
  if ARow > 0 then
  begin
    if AValue.ToUpper = 'NULL' then
      AValue := EmptyStr;

    lCampo := WebDBTableControl1.Columns[ACol].DataField;
    lTemErro := Trim(WebDBTableControl1.DataSource.DataSet.FieldByName('erro').AsString) <> EmptyStr;
    lIgnorarPinturaErro := IndexStr(lCampo, ['selecionado', 'associacao.status',
      'associacao.imagem_aprovacao', 'fsprod_imagem_cds']) >= 0;

    if lCampo = 'fsprod_imagem_cds' then
    begin
      lImagemSrc := Trim(AValue);

      if SameText(lImagemSrc, 'null') or SameText(lImagemSrc, 'undefined') then
        lImagemSrc := EmptyStr;

      if lImagemSrc = EmptyStr then
        lImagemSrc := 'assets/img/produto_sem_imagem.webp';

      AValue := '<div style="display:inline-block;width:72px;height:72px;">' +
        '<img src="' + lImagemSrc +
        '" style="width:72px;height:72px;object-fit:cover;border-radius:6px;" title="Imagem Fs_Prod">' +
        '</div>';
      Exit;
    end;

    if lCampo = 'associacao.imagem_aprovacao' then
    begin
      lCodigoAssociacao := Produtos_AssociacaoDatasetassociacaoid.AsString;
      lNovaImagemField := Produtos_AssociacaoDataset.FieldByName('nova_imagem');

      if lNovaImagemField.IsNull then
        lImagemSrc := AValue
      else
        lImagemSrc := Trim(lNovaImagemField.AsString);

      if SameText(Trim(lImagemSrc), 'null') or SameText(Trim(lImagemSrc), 'undefined') then
        lImagemSrc := EmptyStr;

      lTemImagem := Trim(lImagemSrc) <> EmptyStr;

      if Trim(lImagemSrc) = EmptyStr then
        lImagemSrc := 'assets/img/produto_sem_imagem.webp';

      AValue := '<div data-associacao="' + lCodigoAssociacao + '" style="position:relative;display:inline-block;width:72px;height:72px;overflow:visible;">' +
        '<img id="imgAssoc_' + lCodigoAssociacao + '" data-associacao="' + lCodigoAssociacao +
        '" data-action="assoc-img-select" data-recno="' + IntToStr(Produtos_AssociacaoDataset.RecNo) +
        '" src="' + lImagemSrc +
        '" style="width:72px;height:72px;object-fit:cover;border-radius:6px;cursor:pointer;" title="Clique para alterar imagem">' +
        '<button id="btnRemoverImgAssoc_' + lCodigoAssociacao + '" type="button" class="btn btn-danger btn-sm rounded-circle"' +
        ' data-action="assoc-img-remove" data-associacao="' + lCodigoAssociacao + '"' +
        ' data-recno="' + IntToStr(Produtos_AssociacaoDataset.RecNo) + '"' +
        ' style="position:absolute;top:2px;right:2px;padding:0;line-height:1;width:20px;height:20px;z-index:3;opacity:0.95;' +
        IfThen(lTemImagem, EmptyStr, 'display:none;') +
        '" title="Remover imagem">&times;</button>' +
        '</div>';
      Exit;
    end;

    if lCampo = 'selecionado' then
    begin
      lCodigoAssociacao := Produtos_AssociacaoDatasetassociacaoid.AsString;
      lChecked := EmptyStr;

      if Produtos_AssociacaoDatasetselecionado.AsBoolean then
        lChecked := ' checked';

      AValue := '<input type="checkbox" class="form-check-input"' + lChecked +
        ' data-associacao="' + lCodigoAssociacao + '"' +
        ' onclick="event.stopPropagation();"' +
        ' onchange="window.fsProdAssociacaoApplySelecionado && window.fsProdAssociacaoApplySelecionado(''' +
        lCodigoAssociacao + ''', this.checked, ' + IntToStr(Produtos_AssociacaoDataset.RecNo) + ');">';
      Exit;
    end;

    if (Produtos_AssociacaoDataset.FieldByName('associacao.status').AsInteger = 3) and
      (IndexStr(lCampo, ['nome',
      'codigo_barras']) >= 0) then
    begin
      lCodigoAssociacao := Produtos_AssociacaoDataset.FieldByName('associacao.id').AsString;
      AValue := GetHtmlCampoEditavelGrid(lCodigoAssociacao, lCampo, AValue,
        Produtos_AssociacaoDataset.RecNo);

      if lTemErro and (not lIgnorarPinturaErro) then
        AValue := '<span class="text-danger">' + AValue + '</span>';

      Exit;
    end;

    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['associacao.status', 'aliado.Nome_Fantasia']) of
      0:
      begin
        case StrToInt(AValue) of
          2 : AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 1px;padding-left: 5px;">VALIDAR FOTO</div>';
          3 : AValue := '<div class="rounded-pill" style="background-color: #0054C3;color:white; padding-right: 1px;padding-left: 5px;">VALIDAR CADASTRO</div>';
        end;
      end;
      1 : AValue := AValue.ToUpper;
    end;

    if lTemErro and (not lIgnorarPinturaErro) then
      AValue := '<p class="text-danger">' + AValue + '</p>';
  end;
end;

procedure TFViewProdutos_AssociacaoList.SincronizarNovaImagemComImagemAprovacao;
var
  lRecNo: Integer;
begin
  if not Produtos_AssociacaoDataset.Active then
    Exit;

  lRecNo := Produtos_AssociacaoDataset.RecNo;

  Produtos_AssociacaoDataset.DisableControls;
  try
    Produtos_AssociacaoDataset.First;
    while not Produtos_AssociacaoDataset.Eof do
    begin
      Produtos_AssociacaoDataset.Edit;
      Produtos_AssociacaoDataset.FieldByName('nova_imagem').AsString :=
        Produtos_AssociacaoDataset.FieldByName('associacao.imagem_aprovacao').AsString;
      Produtos_AssociacaoDatasetselecionado.AsBoolean := False;
      Produtos_AssociacaoDatasetfsprod_nome_cds.AsString :=
        Produtos_AssociacaoDatasetassociacaofsprodnome.AsString;
      Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.AsString :=
        Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.AsString;
      Produtos_AssociacaoDatasetfsprod_imagem_cds.AsString :=
        Produtos_AssociacaoDatasetassociacaofsprodimagem.AsString;
      Produtos_AssociacaoDataset.Post;
      Produtos_AssociacaoDataset.Next;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;

  if (lRecNo > 0) and (lRecNo <= Produtos_AssociacaoDataset.RecordCount) then
    Produtos_AssociacaoDataset.RecNo := lRecNo;
end;

procedure TFViewProdutos_AssociacaoList.Produtos_AssociacaoDatasetAfterOpen(
  DataSet: TDataSet);
begin
  SincronizarNovaImagemComImagemAprovacao;
  AtualizarTextoBotaoMarcarTodos;
end;

procedure TFViewProdutos_AssociacaoList.RemoverRegistrosSemErro(
  var pDicionarioErros: TDictionary<Integer, string>);
var
  lCodigoAssociacao : Integer;
begin
  Produtos_AssociacaoDataset.First;
  Produtos_AssociacaoDataset.DisableControls;

  try
    while not Produtos_AssociacaoDataset.Eof do
    begin
      if Produtos_AssociacaoDataset.FieldByName('selecionado').AsBoolean then
      begin
        lCodigoAssociacao := Produtos_AssociacaoDataset.FieldByName('associacao.id').AsInteger;

        if not pDicionarioErros.ContainsKey(lCodigoAssociacao) then
          Produtos_AssociacaoDataset.Delete;
      end;

      Produtos_AssociacaoDataset.Next;
    end;
  finally
    Produtos_AssociacaoDataset.EnableControls;
  end;
end;

procedure TFViewProdutos_AssociacaoList.WebFormCreate(Sender: TObject);
begin
    asm
    var lForm = this;

    window.fsProdAssociacaoApplyEdit = function(pCodigoAssociacao, pCampo, pValor, pRecNo) {
      lForm.AplicarEdicaoGridNoDataSet(pCodigoAssociacao, pCampo, pValor, pRecNo || 0);
    }

    window.fsProdAssociacaoApplySelecionado = function(pCodigoAssociacao, pSelecionado, pRecNo) {
      lForm.AplicarSelecionadoNoDataSet(pCodigoAssociacao, !!pSelecionado, pRecNo || 0);
    }

    window.fsProdAssociacaoSelecionarImagem = function(pCodigoAssociacao, pRecNo) {
      lForm.SelecionarImagemGrid(pCodigoAssociacao, pRecNo || 0);
    }

    window.fsProdAssociacaoRemoverImagem = function(pCodigoAssociacao, pRecNo) {
      var lImgById = document.getElementById('imgAssoc_' + pCodigoAssociacao);
      var lBtnRemover = document.getElementById('btnRemoverImgAssoc_' + pCodigoAssociacao);
      if (lImgById) {
        lImgById.src = 'assets/img/produto_sem_imagem.webp';
      }

      if (lBtnRemover) {
        lBtnRemover.style.display = 'none';
      }

      lForm.AplicarImagemGridNoDataSet(pCodigoAssociacao, pRecNo || 0, '', true);
    }

    var lTable = document.getElementById('view.produtos_associacao.list.table');
    if (lTable) {
      lTable.onclick = function(e) {
        var lTarget = e.target;
        if (!lTarget || !lTarget.getAttribute) {
          return;
        }

        var lAction = lTarget.getAttribute('data-action');
        var lCodigoAssociacao = lTarget.getAttribute('data-associacao') || '';
        var lRecNo = parseInt(lTarget.getAttribute('data-recno') || '0', 10) || 0;

        if (lAction === 'assoc-img-select') {
          e.preventDefault();
          window.fsProdAssociacaoSelecionarImagem && window.fsProdAssociacaoSelecionarImagem(lCodigoAssociacao, lRecNo);
          return;
        }

        if (lAction === 'assoc-img-remove') {
          e.preventDefault();
          e.stopPropagation();
          window.fsProdAssociacaoRemoverImagem && window.fsProdAssociacaoRemoverImagem(lCodigoAssociacao, lRecNo);
          return;
        }
      }
    }

    var lGridImagePicker = document.getElementById('gridImagePicker');
    if (lGridImagePicker) {
      lGridImagePicker.onchange = function(e) {
        var lPending = window.fsProdAssociacaoImagemPending || null;
        var lFile = (e.target && e.target.files && e.target.files[0]) ? e.target.files[0] : null;

        if (!lPending || !lFile) {
          return;
        }

        var lExt = (lFile.name.split('.').pop() || '').toLowerCase();
        var lExtOk = ['png', 'jpg', 'jpeg', 'webp'].indexOf(lExt) >= 0;
        if (!lExtOk) {
          lForm.ExibirMensagemInformacao('Formato de imagem invalido! Formatos validos: png | jpg | jpeg | webp');
          return;
        }

        if ((lFile.size || 0) > (1 * 1024 * 1024)) {
          lForm.ExibirMensagemInformacao('Tamanho de imagem invalido! Insira uma imagem de ate 1MB.');
          return;
        }

        var lReader = new FileReader();
        lReader.onload = function(ev) {
          var lDataUrl = (ev && ev.target && ev.target.result) ? String(ev.target.result) : '';
          if (!lDataUrl) {
            return;
          }

          lForm.AplicarImagemGridNoDataSet(lPending.associacao, lPending.recno, lDataUrl, false);

          var lImgById = document.getElementById('imgAssoc_' + lPending.associacao);
          var lBtnRemover = document.getElementById('btnRemoverImgAssoc_' + lPending.associacao);
          if (lImgById) {
            lImgById.src = lDataUrl;
          }

          if (lBtnRemover) {
            lBtnRemover.style.display = '';
          }
        };

        lReader.readAsDataURL(lFile);
      }
    }

    var lBtn = document.getElementById('btnMarcarDesmarcarTodos');
    if (lBtn) {
      lBtn.onclick = function(e) {
        e.preventDefault();
        lForm.MarcarDesmarcarTodosNoDataSet();
      }
    }
  end;

  TUtils.SetValorDicionarioClasses('produtos_associacao', 'active');
  TUtils.SetValorDicionarioClasses('fs_produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_fs_produtos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Produtos_AssociacaoDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.FDatasetPlugin.FFilterPadrao := '((associacao.status eq 2) or (associacao.status eq 3))';
  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'alteracao desc';
  FGridPlugin.SetPageSize(50);
  FGridPlugin.SetFilterText('');
  FGridPlugin.Load;

  AtualizarTextoBotaoMarcarTodos;
end;

procedure TFViewProdutos_AssociacaoList.XDataWebClientAssociacaoError(
  Error: TXDataClientError);
var
  lJsonArray: TJSArray;
  lIndice,
  lCodAssociacao : Integer;
  lJsonObject : TJSObject;
  lDicionarioErros : TDictionary<Integer, string>;
begin
  lJsonArray := TJSArray(TJSJSON.parse(Error.ErrorMessage));
  lDicionarioErros := TDictionary<Integer, string>.Create;

  try
    for lIndice := 0 to lJsonArray.Length - 1 do
    begin
      lJsonObject := TJSObject(lJsonArray[lIndice]);
      lCodAssociacao := Integer(lJsonObject['codigo_associacao']);
      lDicionarioErros.Add(lCodAssociacao, EmptyStr);

      if Produtos_AssociacaoDataset.Locate('associacao.id', lCodAssociacao,[loCaseInsensitive,loPartialKey]) then
      begin
        Produtos_AssociacaoDataset.Edit;
        Produtos_AssociacaoDataset.FieldByName('erro').AsString := string(lJsonObject['erro']);
        Produtos_AssociacaoDataset.Post;
      end;
    end;

    RemoverRegistrosSemErro(lDicionarioErros);
  finally
    if Assigned(lDicionarioErros) then
      FreeAndNil(lDicionarioErros);
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, 'Algum(ns) registro(s) não foi(ram) associados!' +
    sLineBreak + 'Confira o erro na tabela.');
end;

procedure TFViewProdutos_AssociacaoList.XDataWebClientAssociacaoLoad(
  Response: TXDataClientResponse);
begin
  TUtils.OcultarDivLoading;

  FGridPlugin.Load;
end;

procedure TFViewProdutos_AssociacaoList.XDataWebClientGetFsProdLoad(
  Response: TXDataClientResponse);
var
  lJsonTexto: string;
  lJsonBruto: JSValue;
  lResposta: TJSObject;
  lResultadoArray: TJSArray;
  lValues: TJSArray;
  lItem: TJSObject;
  lResultadoObjeto: TJSObject;
  lCodigoAssociacao: string;
  lCodigoBarrasConsultado: string;
  lNomeFsProd: string;
  lCodigoBarrasFsProd: string;
  lImagemFsProd: string;
begin
  TUtils.OcultarDivLoading;

  lCodigoAssociacao := FFsProdLookupAssociacaoId;
  lCodigoBarrasConsultado := FFsProdLookupCodigoBarras;
  FFsProdLookupAssociacaoId := EmptyStr;
  FFsProdLookupCodigoBarras := EmptyStr;

  if (Trim(lCodigoAssociacao) = EmptyStr) or
    (Trim(lCodigoBarrasConsultado) = EmptyStr) then
    Exit;

  lItem := nil;

  lJsonTexto := Trim(Response.ResponseText);
  if lJsonTexto <> EmptyStr then
  begin
    lJsonBruto := TJSJSON.parse(lJsonTexto);
    if JS.isArray(lJsonBruto) then
      lResultadoArray := TJSArray(lJsonBruto)
    else
      lResposta := TJSObject(lJsonBruto);
  end;

  if not Assigned(lResposta) then
    lResposta := Response.ResultAsObject;

  if Assigned(lResposta) then
  begin
    if Assigned(lResposta['result']) then
    begin
      if JS.isArray(lResposta['result']) then
        lResultadoArray := TJSArray(lResposta['result'])
      else
        lResultadoObjeto := TJSObject(lResposta['result']);
    end
    else
      lResultadoObjeto := lResposta;

    if Assigned(lResultadoObjeto) then
      lItem := lResultadoObjeto;
  end;

  if Assigned(lItem) and
    (Trim(string(lItem['nome'])) = EmptyStr) and
    (Trim(string(lItem['codigo_barras'])) = EmptyStr) then
  begin
    lValues := TJSArray(lItem['value']);
    if Assigned(lValues) and (lValues.Length > 0) then
      lItem := TJSObject(lValues[0]);
  end;

  if (not Assigned(lItem)) or
    ((Trim(string(lItem['nome'])) = EmptyStr) and
     (Trim(string(lItem['codigo_barras'])) = EmptyStr)) then
  begin
    if not Assigned(lResultadoArray) then
      lResultadoArray := Response.ResultAsArray;

    if Assigned(lResultadoArray) and (lResultadoArray.Length > 0) then
      lItem := TJSObject(lResultadoArray[0]);
  end;

  if not Assigned(lItem) then
    Exit;

  lNomeFsProd := Trim(string(lItem['nome']));
  lCodigoBarrasFsProd := Trim(string(lItem['codigo_barras']));
  lImagemFsProd := Trim(string(lItem['imagem']));

  if SameText(lNomeFsProd, 'null') or SameText(lNomeFsProd, 'undefined') then
    lNomeFsProd := EmptyStr;

  if SameText(lCodigoBarrasFsProd, 'null') or SameText(lCodigoBarrasFsProd, 'undefined') then
    lCodigoBarrasFsProd := EmptyStr;

  if SameText(lImagemFsProd, 'null') or SameText(lImagemFsProd, 'undefined') then
    lImagemFsProd := EmptyStr;

  AtualizarFsProdPorCodigoBarras(lCodigoAssociacao, lCodigoBarrasConsultado,
    lNomeFsProd, lCodigoBarrasFsProd, lImagemFsProd);
end;

procedure TFViewProdutos_AssociacaoList.XDataWebClientGetFsProdError(
  Error: TXDataClientError);
begin
  TUtils.OcultarDivLoading;

  FFsProdLookupAssociacaoId := EmptyStr;
  FFsProdLookupCodigoBarras := EmptyStr;
end;

procedure TFViewProdutos_AssociacaoList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.produtos_associacao.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.produtos_associacao.list.table');
  lcPaginator := TListControl.Create('view.produtos_associacao.list.pagination');
  btnAprovar := TButton.Create('btnAprovar');
  btnReprovar := TButton.Create('btnReprovar');
  cbbAssociacaoStatus := TComboBox.Create('cbbAssociacaoStatus');
  divAliado := THTMLDiv.Create('view_usuarios_form_lbaliado_error_div');
  lblAliado := TLabel.Create('lblAliado');
  edtAliadoNome := TEdit.Create('edtAliadoNome');
  btnPesquisarAliado := TButton.Create('btnPesquisarAliado');
  btnPesquisarAssociacao := TButton.Create('btnPesquisarAssociacao');
  Produtos_AssociacaoDataset := TXDataWebDataSet.Create(Self);
  Produtos_AssociacaoDatasetassociacaostatus := TXDataWebDatasetField.Create(Self);
  Produtos_AssociacaoDatasetassociacaoinclusao := TDateTimeField.Create(Self);
  Produtos_AssociacaoDatasetassociacaoalteracao := TDateTimeField.Create(Self);
  Produtos_AssociacaoDatasetaliadoNome_Fantasia := TXDataWebDatasetField.Create(Self);
  Produtos_AssociacaoDatasetnome := TStringField.Create(Self);
  Produtos_AssociacaoDatasetcodigo_barras := TStringField.Create(Self);
  Produtos_AssociacaoDatasetassociacaofsprodnome := TXDataWebDatasetField.Create(Self);
  Produtos_AssociacaoDatasetassociacaoimagem_aprovacao := TXDataWebDatasetField.Create(Self);
  Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras := TXDataWebDatasetField.Create(Self);
  Produtos_AssociacaoDatasetassociacaofsprodid := TXDataWebDatasetField.Create(Self);
  Produtos_AssociacaoDatasetid := TIntegerField.Create(Self);
  Produtos_AssociacaoDatasetselecionado := TBooleanField.Create(Self);
  Produtos_AssociacaoDatasetnova_imagem := TStringField.Create(Self);
  Produtos_AssociacaoDatasetfsprod_nome_cds := TStringField.Create(Self);
  Produtos_AssociacaoDatasetfsprod_codigo_barras_cds := TStringField.Create(Self);
  Produtos_AssociacaoDatasetfsprod_imagem_cds := TStringField.Create(Self);
  Produtos_AssociacaoDatasetassociacaofsprodimagem := TStringField.Create(Self);
  Produtos_AssociacaoDataseterro := TStringField.Create(Self);
  Produtos_AssociacaoDatasetassociacaoid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  XDataWebClientAssociacao := TXDataWebClient.Create(Self);
  XDataWebClientGetFsProd := TXDataWebClient.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnAprovar.BeforeLoadDFMValues;
  btnReprovar.BeforeLoadDFMValues;
  cbbAssociacaoStatus.BeforeLoadDFMValues;
  divAliado.BeforeLoadDFMValues;
  lblAliado.BeforeLoadDFMValues;
  edtAliadoNome.BeforeLoadDFMValues;
  btnPesquisarAliado.BeforeLoadDFMValues;
  btnPesquisarAssociacao.BeforeLoadDFMValues;
  Produtos_AssociacaoDataset.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaostatus.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaoinclusao.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaoalteracao.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetnome.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetcodigo_barras.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaofsprodnome.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaoimagem_aprovacao.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaofsprodid.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetid.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetselecionado.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetnova_imagem.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetfsprod_nome_cds.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetfsprod_imagem_cds.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaofsprodimagem.BeforeLoadDFMValues;
  Produtos_AssociacaoDataseterro.BeforeLoadDFMValues;
  Produtos_AssociacaoDatasetassociacaoid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  XDataWebClientAssociacao.BeforeLoadDFMValues;
  XDataWebClientGetFsProd.BeforeLoadDFMValues;
  try
    Name := 'FViewProdutos_AssociacaoList';
    Width := 405;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 288;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 6;
    WebDBTableControl1.Width := 353;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'selecionado';
      DataType := cdCheck;
      Title := 'selecionado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'associacao.id';
      Title := 'C'#243'd.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'associacao.status';
      Title := 'Status';
      Width := 330;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'associacao.imagem_aprovacao';
      Title := 'Imagem';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fsprod_imagem_cds';
      Title := 'Imagem Fs_Prod';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'Nome Cad.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'C'#243'd. Barras Cad.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fsprod_nome_cds';
      Title := 'Nome Fs_Prod';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'fsprod_codigo_barras_cds';
      Title := 'C'#243'd. Barras Fs_Prod';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'erro';
      Title := 'Erro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'associacao.inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'associacao.alteracao';
      Title := 'Altera'#231#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 128;
    lcPaginator.Top := 277;
    lcPaginator.Width := 145;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnAprovar.SetParentComponent(Self);
    btnAprovar.Name := 'btnAprovar';
    btnAprovar.Left := 8;
    btnAprovar.Top := 432;
    btnAprovar.Width := 96;
    btnAprovar.Height := 25;
    btnAprovar.Caption := 'Aprovar';
    btnAprovar.ChildOrder := 24;
    btnAprovar.HeightPercent := 100.000000000000000000;
    btnAprovar.TabStop := False;
    btnAprovar.WidthPercent := 100.000000000000000000;
    SetEvent(btnAprovar, Self, 'OnClick', 'btnAprovarClick');
    btnReprovar.SetParentComponent(Self);
    btnReprovar.Name := 'btnReprovar';
    btnReprovar.Left := 110;
    btnReprovar.Top := 432;
    btnReprovar.Width := 96;
    btnReprovar.Height := 25;
    btnReprovar.Caption := 'Reprovar';
    btnReprovar.ChildOrder := 24;
    btnReprovar.HeightPercent := 100.000000000000000000;
    btnReprovar.TabStop := False;
    btnReprovar.WidthPercent := 100.000000000000000000;
    SetEvent(btnReprovar, Self, 'OnClick', 'btnReprovarClick');
    cbbAssociacaoStatus.SetParentComponent(Self);
    cbbAssociacaoStatus.Name := 'cbbAssociacaoStatus';
    cbbAssociacaoStatus.Left := 8;
    cbbAssociacaoStatus.Top := 328;
    cbbAssociacaoStatus.Width := 178;
    cbbAssociacaoStatus.Height := 21;
    cbbAssociacaoStatus.HeightPercent := 100.000000000000000000;
    cbbAssociacaoStatus.TabStop := False;
    cbbAssociacaoStatus.Text := 'TODOS';
    cbbAssociacaoStatus.WidthPercent := 100.000000000000000000;
    cbbAssociacaoStatus.ItemIndex := 0;
    cbbAssociacaoStatus.Items.BeginUpdate;
    try
      cbbAssociacaoStatus.Items.Clear;
      cbbAssociacaoStatus.Items.Add('TODOS');
      cbbAssociacaoStatus.Items.Add('VALIDAR FOTO');
      cbbAssociacaoStatus.Items.Add('VALIDAR CADASTRO');
    finally
      cbbAssociacaoStatus.Items.EndUpdate;
    end;
    divAliado.SetParentComponent(Self);
    divAliado.Name := 'divAliado';
    divAliado.Left := 8;
    divAliado.Top := 355;
    divAliado.Width := 178;
    divAliado.Height := 33;
    divAliado.ChildOrder := 19;
    divAliado.Role := '';
    divAliado.Visible := False;
    lblAliado.SetParentComponent(divAliado);
    lblAliado.Name := 'lblAliado';
    lblAliado.Left := 8;
    lblAliado.Top := 7;
    lblAliado.Width := 33;
    lblAliado.Height := 13;
    lblAliado.Caption := 'Aliado:';
    lblAliado.HeightPercent := 100.000000000000000000;
    lblAliado.WidthPercent := 100.000000000000000000;
    edtAliadoNome.SetParentComponent(divAliado);
    edtAliadoNome.Name := 'edtAliadoNome';
    edtAliadoNome.Left := 53;
    edtAliadoNome.Top := 3;
    edtAliadoNome.Width := 80;
    edtAliadoNome.Height := 22;
    edtAliadoNome.ChildOrder := 21;
    edtAliadoNome.Enabled := False;
    edtAliadoNome.HeightPercent := 100.000000000000000000;
    edtAliadoNome.WidthPercent := 100.000000000000000000;
    btnPesquisarAliado.SetParentComponent(divAliado);
    btnPesquisarAliado.Name := 'btnPesquisarAliado';
    btnPesquisarAliado.Left := 139;
    btnPesquisarAliado.Top := 4;
    btnPesquisarAliado.Width := 30;
    btnPesquisarAliado.Height := 21;
    btnPesquisarAliado.ChildOrder := 22;
    btnPesquisarAliado.HeightPercent := 100.000000000000000000;
    btnPesquisarAliado.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarAliado, Self, 'OnClick', 'btnPesquisarAliadoClick');
    btnPesquisarAssociacao.SetParentComponent(Self);
    btnPesquisarAssociacao.Name := 'btnPesquisarAssociacao';
    btnPesquisarAssociacao.Left := 212;
    btnPesquisarAssociacao.Top := 432;
    btnPesquisarAssociacao.Width := 96;
    btnPesquisarAssociacao.Height := 25;
    btnPesquisarAssociacao.Caption := 'Pesquisar';
    btnPesquisarAssociacao.ChildOrder := 24;
    btnPesquisarAssociacao.HeightPercent := 100.000000000000000000;
    btnPesquisarAssociacao.TabStop := False;
    btnPesquisarAssociacao.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarAssociacao, Self, 'OnClick', 'btnPesquisarAssociacaoClick');
    Produtos_AssociacaoDataset.SetParentComponent(Self);
    Produtos_AssociacaoDataset.Name := 'Produtos_AssociacaoDataset';
    Produtos_AssociacaoDataset.AfterOpen := Produtos_AssociacaoDatasetAfterOpen;
    Produtos_AssociacaoDataset.EntitySetName := 'Produtos';
    Produtos_AssociacaoDataset.Connection := DMConnection.ApiConnection;
    Produtos_AssociacaoDataset.Left := 72;
    Produtos_AssociacaoDataset.Top := 56;
    Produtos_AssociacaoDatasetassociacaostatus.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaostatus.Name := 'Produtos_AssociacaoDatasetassociacaostatus';
    Produtos_AssociacaoDatasetassociacaostatus.Tag := 1;
    Produtos_AssociacaoDatasetassociacaostatus.FieldName := 'associacao.status';
    Produtos_AssociacaoDatasetassociacaoinclusao.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaoinclusao.Name := 'Produtos_AssociacaoDatasetassociacaoinclusao';
    Produtos_AssociacaoDatasetassociacaoinclusao.Tag := 1;
    Produtos_AssociacaoDatasetassociacaoinclusao.FieldName := 'associacao.inclusao';
    Produtos_AssociacaoDatasetassociacaoinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Produtos_AssociacaoDatasetassociacaoalteracao.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaoalteracao.Name := 'Produtos_AssociacaoDatasetassociacaoalteracao';
    Produtos_AssociacaoDatasetassociacaoalteracao.Tag := 1;
    Produtos_AssociacaoDatasetassociacaoalteracao.FieldName := 'associacao.alteracao';
    Produtos_AssociacaoDatasetassociacaoalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Produtos_AssociacaoDatasetaliadoNome_Fantasia.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetaliadoNome_Fantasia.Name := 'Produtos_AssociacaoDatasetaliadoNome_Fantasia';
    Produtos_AssociacaoDatasetaliadoNome_Fantasia.Tag := 1;
    Produtos_AssociacaoDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    Produtos_AssociacaoDatasetnome.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetnome.Name := 'Produtos_AssociacaoDatasetnome';
    Produtos_AssociacaoDatasetnome.Tag := 1;
    Produtos_AssociacaoDatasetnome.FieldName := 'nome';
    Produtos_AssociacaoDatasetnome.Required := True;
    Produtos_AssociacaoDatasetnome.Size := 255;
    Produtos_AssociacaoDatasetcodigo_barras.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetcodigo_barras.Name := 'Produtos_AssociacaoDatasetcodigo_barras';
    Produtos_AssociacaoDatasetcodigo_barras.Tag := 1;
    Produtos_AssociacaoDatasetcodigo_barras.FieldName := 'codigo_barras';
    Produtos_AssociacaoDatasetcodigo_barras.Size := 255;
    Produtos_AssociacaoDatasetassociacaofsprodnome.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaofsprodnome.Name := 'Produtos_AssociacaoDatasetassociacaofsprodnome';
    Produtos_AssociacaoDatasetassociacaofsprodnome.Tag := 1;
    Produtos_AssociacaoDatasetassociacaofsprodnome.FieldName := 'associacao.fsprod.nome';
    Produtos_AssociacaoDatasetassociacaoimagem_aprovacao.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaoimagem_aprovacao.Name := 'Produtos_AssociacaoDatasetassociacaoimagem_aprovacao';
    Produtos_AssociacaoDatasetassociacaoimagem_aprovacao.Tag := 1;
    Produtos_AssociacaoDatasetassociacaoimagem_aprovacao.FieldName := 'associacao.imagem_aprovacao';
    Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.Name := 'Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras';
    Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.Tag := 1;
    Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.FieldName := 'associacao.fsprod.codigo_barras';
    Produtos_AssociacaoDatasetassociacaofsprodid.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaofsprodid.Name := 'Produtos_AssociacaoDatasetassociacaofsprodid';
    Produtos_AssociacaoDatasetassociacaofsprodid.Tag := 1;
    Produtos_AssociacaoDatasetassociacaofsprodid.FieldName := 'associacao.fsprod.id';
    Produtos_AssociacaoDatasetid.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetid.Name := 'Produtos_AssociacaoDatasetid';
    Produtos_AssociacaoDatasetid.Tag := 1;
    Produtos_AssociacaoDatasetid.FieldName := 'id';
    Produtos_AssociacaoDatasetid.Required := True;
    Produtos_AssociacaoDatasetselecionado.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetselecionado.Name := 'Produtos_AssociacaoDatasetselecionado';
    Produtos_AssociacaoDatasetselecionado.Tag := 1;
    Produtos_AssociacaoDatasetselecionado.FieldName := 'selecionado';
    Produtos_AssociacaoDatasetnova_imagem.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetnova_imagem.Name := 'Produtos_AssociacaoDatasetnova_imagem';
    Produtos_AssociacaoDatasetnova_imagem.Tag := 1;
    Produtos_AssociacaoDatasetnova_imagem.FieldName := 'nova_imagem';
    Produtos_AssociacaoDatasetfsprod_nome_cds.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetfsprod_nome_cds.Name := 'Produtos_AssociacaoDatasetfsprod_nome_cds';
    Produtos_AssociacaoDatasetfsprod_nome_cds.Tag := 1;
    Produtos_AssociacaoDatasetfsprod_nome_cds.FieldName := 'fsprod_nome_cds';
    Produtos_AssociacaoDatasetfsprod_nome_cds.Size := 255;
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.Name := 'Produtos_AssociacaoDatasetfsprod_codigo_barras_cds';
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.Tag := 1;
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.FieldName := 'fsprod_codigo_barras_cds';
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.Size := 255;
    Produtos_AssociacaoDatasetfsprod_imagem_cds.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetfsprod_imagem_cds.Name := 'Produtos_AssociacaoDatasetfsprod_imagem_cds';
    Produtos_AssociacaoDatasetfsprod_imagem_cds.Tag := 1;
    Produtos_AssociacaoDatasetfsprod_imagem_cds.FieldName := 'fsprod_imagem_cds';
    Produtos_AssociacaoDatasetfsprod_imagem_cds.Size := 255;
    Produtos_AssociacaoDatasetassociacaofsprodimagem.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaofsprodimagem.Name := 'Produtos_AssociacaoDatasetassociacaofsprodimagem';
    Produtos_AssociacaoDatasetassociacaofsprodimagem.Tag := 1;
    Produtos_AssociacaoDatasetassociacaofsprodimagem.FieldName := 'associacao.fsprod.imagem';
    Produtos_AssociacaoDataseterro.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDataseterro.Name := 'Produtos_AssociacaoDataseterro';
    Produtos_AssociacaoDataseterro.Tag := 1;
    Produtos_AssociacaoDataseterro.FieldName := 'erro';
    Produtos_AssociacaoDatasetassociacaoid.SetParentComponent(Produtos_AssociacaoDataset);
    Produtos_AssociacaoDatasetassociacaoid.Name := 'Produtos_AssociacaoDatasetassociacaoid';
    Produtos_AssociacaoDatasetassociacaoid.Tag := 1;
    Produtos_AssociacaoDatasetassociacaoid.FieldName := 'associacao.id';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Produtos_AssociacaoDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 112;
    XDataWebClientAssociacao.SetParentComponent(Self);
    XDataWebClientAssociacao.Name := 'XDataWebClientAssociacao';
    XDataWebClientAssociacao.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientAssociacao, Self, 'OnLoad', 'XDataWebClientAssociacaoLoad');
    SetEvent(XDataWebClientAssociacao, Self, 'OnError', 'XDataWebClientAssociacaoError');
    XDataWebClientAssociacao.Left := 312;
    XDataWebClientAssociacao.Top := 280;
    XDataWebClientGetFsProd.SetParentComponent(Self);
    XDataWebClientGetFsProd.Name := 'XDataWebClientGetFsProd';
    XDataWebClientGetFsProd.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientGetFsProd, Self, 'OnLoad', 'XDataWebClientGetFsProdLoad');
    SetEvent(XDataWebClientGetFsProd, Self, 'OnError', 'XDataWebClientGetFsProdError');
    XDataWebClientGetFsProd.Left := 312;
    XDataWebClientGetFsProd.Top := 336;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnAprovar.AfterLoadDFMValues;
    btnReprovar.AfterLoadDFMValues;
    cbbAssociacaoStatus.AfterLoadDFMValues;
    divAliado.AfterLoadDFMValues;
    lblAliado.AfterLoadDFMValues;
    edtAliadoNome.AfterLoadDFMValues;
    btnPesquisarAliado.AfterLoadDFMValues;
    btnPesquisarAssociacao.AfterLoadDFMValues;
    Produtos_AssociacaoDataset.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaostatus.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaoinclusao.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaoalteracao.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetnome.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetcodigo_barras.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaofsprodnome.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaoimagem_aprovacao.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaofsprodcodigo_barras.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaofsprodid.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetid.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetselecionado.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetnova_imagem.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetfsprod_nome_cds.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetfsprod_codigo_barras_cds.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetfsprod_imagem_cds.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaofsprodimagem.AfterLoadDFMValues;
    Produtos_AssociacaoDataseterro.AfterLoadDFMValues;
    Produtos_AssociacaoDatasetassociacaoid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    XDataWebClientAssociacao.AfterLoadDFMValues;
    XDataWebClientGetFsProd.AfterLoadDFMValues;
  end;
end;

end.
